module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="background">\n	<div class="form-container">\n		<form class="base-form activate-game-container js-activate-game-form">\n			<h1>Register for NRL '+
((__t=( game_title ))==null?'':_.escape(__t))+
' game</h1>\n			<p>You have not yet registered for NRL '+
((__t=( game_title ))==null?'':_.escape(__t))+
'. Please accept the Terms and Conditions below and click register to start picking your team.</p>\n			<div class="form-group">\n				<label for="t_and_cs" class="checkbox-container">\n					<input type="checkbox" id="t_and_cs" name="t_and_cs" class="js-t-and-cs"\n											 value="1" '+
((__t=( (t_and_cs == 1) ? 'checked' : '' ))==null?'':_.escape(__t))+
' >\n					<span class="checkmark"></span>\n					<span class="label-text">I accept the <a href="/help/terms-and-conditions" class="text-link" target="_blank">Terms and Conditions</a>*</span>\n				</label>\n				';
 if (errors && errors.t_and_cs) { 
__p+='\n					<div class="error">'+
((__t=( errors.t_and_cs[0] ))==null?'':__t)+
'</div>\n				';
 } 
__p+='\n\n				';
 if (errors && errors.server_side) { 
__p+='\n					<div class="error">'+
((__t=( errors.server_side[0] ))==null?'':__t)+
'</div>\n				';
 } 
__p+='\n			</div>\n			<div class="buttons-wrapper">\n				<button type="submit" class="btn primary-btn js-activate">Register</button>\n			</div>\n		</form>\n		<div class="advert"></div>\n	</div>\n</div>\n';
}
return __p;
};
